// Bridges ui.ts's cast handler to GameScene for a Bind·Momentum cast -- the
// first real effect for the Bind half of the Bind/Separate pair (Separate got
// its own first real effect, Separate·Mass, back in room7). Couples the faced
// object's own movement to the marked Source (or the caster, if nothing is
// marked -- the same source resolution Transfer already uses): every real
// step that locus takes from here on is mirrored onto it (see
// rune-lab/src/sim/casts.ts's movePlayerTo/moveObjectTo/
// propagateBoundMovement), at no Energy cost and ignoring magnitude --
// structural, not a quantity transfer, the same reasoning Separate·Mass's own
// bridge already documents. Reverse at bind time makes the link a mirror
// (moves opposite its source) instead of a shadow (moves the same way).
//
// The event/result shapes themselves live in rune-lab/src/sim/casts.ts with the
// handler that consumes them, and are re-exported here unchanged, so every
// import site reads them from this module -- the same shape every other
// operator effect's bridge already has.
import { BindEffectEvent, BindEffectResult } from '../../rune-lab/src/sim/casts';

export type { BindEffectEvent, BindEffectResult };

type Handler = (event: BindEffectEvent) => BindEffectResult;

let handler: Handler | null = null;

export function onBindEffect(fn: Handler): void {
  handler = fn;
}

export function triggerBindEffect(event: BindEffectEvent): BindEffectResult {
  return handler ? handler(event) : { applied: false, targetName: '', sourceWasSelf: true };
}
